// extracted by mini-css-extract-plugin
export default {"root":"ModalForm_root__8mWRt","content":"ModalForm_content__jo77E","form":"ModalForm_form__slhYb"};